import React, { useMemo, useState, useEffect } from "react";

import DataTable from "react-data-table-component";
import FilterComponent from "./FilterComponent";
import axios from 'axios'
import { API_BASE_PATH, post } from "../Api";
import { Tabs, TabList, TabPanels, Tab, TabPanel, TabIndicator } from '@chakra-ui/react'
import { Button, ButtonGroup, Icon, useColorModeValue } from "@chakra-ui/react";
import { Check, CheckCheck, CheckCircle, Filter, TimerIcon, TimerOffIcon } from "lucide-react";

const FILTERS = [
  { id: "all",   label: "All",   icon: Filter },
  { id: "Approved", label: "Approved", icon: Check },
  { id: "Pending", label: "Pending", icon: TimerIcon },
];
const Table = props => {
    const columns = [
        // {
        //     name: "Request Id",
        //     selector: "id",
        //     sortable: true,
            
        // },
        {
            name: "Driver Name",
            selector: "name",
            sortable: true,
            
        },
        {
            name: "Vehicle Number",
            selector: "vehicleNumber",
            sortable: true,
            
        },
        {
            name: "Vehicle Type",
            selector: "vehicleType",
            sortable: true,
            
        },
        {
            name: "Vehicle Image",
            selector: "vehicleImageURL",
            sortable: true,
            cell: row =>
            (
                <>
                    <img style={{width:"50px",height:"50px",objectFit:"cover",borderRadius:"50%"}} src={row.vehicleImageURL}/>
                      
                </>
            ) 
            
        },
        {
            name: "Driver Image",
            selector: "driverImageURL",
            sortable: true,
            cell: row =>
            (
                <>
                    <img style={{width:"50px",height:"50px",objectFit:"cover",borderRadius:"50%"}} src={row.driverImageURL}/>
                      
                </>
            ) 
            
        },
        {
            name: "Phone",
            selector: "phone",
            sortable: true,
            
        },
        {
            name: "Status",
            selector: "status",
            sortable: true,
            cell: row =>
                (
                    <div className="flex gap-2 items-center">
                   {

                    row.status=="Approved"?<CheckCircle color="green" className="w-5 h-5"></CheckCircle>:
                    <TimerIcon  className="w-5 h-5" color="gray"></TimerIcon>
                    
                   } 
                   { row.status}
                   
                   {/* <PhoneCall color={row.status=="accepted"?"green":"red"} className="w-5 h-5"></PhoneCall> */}
                    </div>
                ) 
            
        },
        {
            name: "Last Updated",
            selector: "lastAccessDate",
            sortable: true,
            cell: row =>
                (
                    <>
                       {new Date(+(row.time||row.lastAccessDate)).toLocaleString()}
                    </>
                ) 
            
        },
        {
            name: "  Buttons  ",
            button: true,
            width: "140px" ,    
            cell: row =>
                (
                    <>
                        <button
                            className="btn btn-primary btn-sm m-0"
                            onClick={() => props.onSelectRecord(row)}
                            style={{ marginRight: "0px",background:"black",marginRight:"2px",borderRadius:"20px"}}
                        >Details</button>
                    </>
                ) 
        }
    ];
    const [data, setData] = useState([]);
    const [tabIndex, setTabIndex] = useState(0)
    const [stateFilter, setStateFilter] = useState("all");

    const [filterText, setFilterText] = React.useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
        false
    );
    const filteredItems = data;
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    var userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
        userInfo = JSON.parse(userInfo);
    }

    const handleTabsChange = (index) => {
        setTabIndex(index)
      }
    
    const onDataFilter=val=>{
        setFilterText(val);
        fetchUsers(1,val);
    }

    useEffect(()=>{
        setResetPaginationToggle(!resetPaginationToggle);

        if(stateFilter){
            fetchUsers(1,filterText);
        }
    },[stateFilter])

    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                onDataFilter("");
            }
        };

        return (
            <FilterComponent
                onFilter={e => onDataFilter(e.target.value)}
                onFilterText={e => onDataFilter(filterText)}
                onSaveFilter={e => setFilterText(e.target.value)}
                onClear={handleClear}
                filterText={filterText}
            />
        );
    }, [filterText, resetPaginationToggle]);

   

    const fetchDataOC=async (page,filter) =>{


        const filterBase={
            searchFilter:{
                vehicleNumber:filter,
                phone:filter
            }
        }


        

        if(stateFilter && stateFilter!="all"){
            filterBase.multiFilter={
                "condition": "AND",
                "rules": [
            
                 
                ]
              }
              if(stateFilter=="Pending"){
                filterBase.multiFilter.rules.push( {
                    "field": "status", "type": "string",
                    "operator": "isnull"
                  });
              }else{
                filterBase.multiFilter.rules.push( {
                    "field": "status", "type": "string",
                    "operator": "equals",
                    "value":stateFilter
                  });
              }
          }

        const response = await post(`/objects/zrider_enquiries/search?partnerId=${userInfo.partnerId}&count=10&offset=${(page-1)*10}&order=lastaccessdate&dir=desc`,filterBase);
        setData(response.rows.map(s=>{
            s.data.id=s.dataKey;
            s.data.status=s.data.status||"Pending";
            s.data.lastAccessDate=s.lastAccessDate;

            return s.data;
        }));
        let count = response.total;
        
        setTotalRows(count);
        return response.data;
    }

    const fetchUsers = async (page,filt) => {
        setLoading(true);
        await fetchDataOC(page,filt);

        setPerPage(10);
        setLoading(false);
    };

    const handlePageChange = page => {
        fetchUsers(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        // setLoading(true);
        // const response = await axios.get(`/objects/outletClusters?lob=${userInfo.accountId}&page=${page}&count=${newPerPage}&resolve=true`);
        // setData(response.data.data);
        // setTotalRows(response.data.length+100);
        // //setPerPage(newPerPage);
        // setLoading(false);
    };

    useEffect(() => {
        // alert("Calling")

        fetchUsers(1); // fetch page 1 of users
    }, [props.updateTime,tabIndex]);

    function FilterButtons({ value = "all", onChange, size = "sm" }) {
        const activeBg   = useColorModeValue("teal.500", "teal.300");
        const activeText = useColorModeValue("white", "gray.800");
      
        return (
          <ButtonGroup className="mt-2" isAttached variant="outline" size={size}>
            {FILTERS.map(({ id, label, icon }) => {
              const isActive = id === value;
              return (
                <Button
                  key={id}
                  leftIcon={<Icon as={icon} boxSize={4} />}
                  borderRadius="full"
                  bg={isActive ? activeBg   : undefined}
                  color={isActive ? activeText : undefined}
                  _hover={{ bg: isActive ? activeBg : "gray.100" }}
                  _dark={{ _hover: { bg: isActive ? activeBg : "gray.700" } }}
                  onClick={() => onChange?.(id)}
                >
                  {label}
                </Button>
              );
            })}
          </ButtonGroup>
        );
      }

     
    return (
      <><FilterButtons value={stateFilter} onChange={setStateFilter} size="sm"></FilterButtons> 
       <DataTable
            title=""
            columns={columns}
            data={filteredItems}
            progressPending={loading}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={subHeaderComponent}
        />
        </>
     
    );
};




export default Table;
